import axios from "axios";
// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 从存储中获取token（如localStorage、Vuex、Pinia等）
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response;
}, error => {
  // 对响应错误做点什么 
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 未授权，token过期或无效
        localStorage.removeItem('token'); // 清除token
        window.location.href = '/'; // 跳转到登录页
        break;
      case 403:
        // 禁止访问，权限不足
        window.location.href = '/'; // 也可以跳转到无权限页面
        break;
    }
  }
  return Promise.reject(error);
});
export const apiURL = 'https://oa.gypszx.com';

// export const apiURL = 'http://192.168.110.125:8091'
export const imageURL = 'https://mssystorems.gzxcjzsoft.com.cn/';
export const http = (path, method, data) => {
  switch (method) {
    case 'post':
      return axios.post(apiURL + path, data, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => res.data);
    case 'put':
      return axios.put(apiURL + path, data, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => res.data);
    case 'delete':
      return axios.delete(apiURL + path).then(res => res.data);
    default:
      return axios.get(apiURL + path).then(res => res.data);
  }
};
export const showMsg = res => {
  let msgType = "error";
  let msgTitle = "错误";
  if (res.status == 1) {
    msgType = "success";
    msgTitle = "成功";
  }
  ElNotification({
    title: msgTitle,
    message: res.message,
    type: msgType
  });
};